module.exports = __webpack_public_path__ + "img/1-2.f743c4ea.png";